import { Box } from '@material-ui/core';

import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import useInViewPort from '@/hooks/useInViewPort';
import { useScreen } from '@/hooks/useScreen';
import { useUIWrapper } from '@/hooks/useUIWrapper';

export const MobileFooter = ({ triggerRef }: { triggerRef: React.RefObject<HTMLElement> }) => {
  const { md } = useScreen();
  const { palette } = useCustomTheme();
  const { leftMenuWidth } = useUIWrapper();

  const resultsInViewport = useInViewPort(triggerRef, { threshold: 0.15 });

  const onButtonClick = () => {
    triggerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const height = '90px';

  if (md) {
    return (
      <Box
        position={'fixed'}
        bottom={resultsInViewport ? `-${height}` : 0}
        left={leftMenuWidth}
        right="0"
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        minHeight={height}
        style={{ transition: 'bottom 0.5s ease' }}
      >
        <StandardButton onClick={onButtonClick} variant="contained">
          <Text tId={'SCROLL_TO_SELECTION_RESULTS'} />
        </StandardButton>
      </Box>
    );
  }

  return (
    <Box
      position={'fixed'}
      bottom={resultsInViewport ? `-${height}` : 0}
      left="0"
      right="0"
      bgcolor={palette.grey[100]}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={height}
      style={{ transition: 'bottom 0.5s ease' }}
    >
      <StandardButton onClick={onButtonClick}>
        <Text tId={'SCROLL_TO_SELECTION_RESULTS_SHORT'} />
      </StandardButton>
    </Box>
  );
};
